// extracted by mini-css-extract-plugin
module.exports = {"expandListButton":"AccordionButton_expandListButton__1ClUd","expandIcon":"AccordionButton_expandIcon__Vwfhr","expanded":"AccordionButton_expanded__YhuNo"};